import { JSX } from 'react';
import { BioCardGrid } from '@ahc-digital/component-library';
import { GetBiographyGridModel } from './C56BiographyGrid.service';
import { C56BiographyGridProps } from './C56BiographyGrid.types';
import { useCreateMarketingRenderingHame } from '@/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C56BiographyGridProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return <BioCardGrid data-component={marketingRenderingName} {...GetBiographyGridModel(props)} />;
};

export default checkDatasourceForRendering<C56BiographyGridProps>(Default);
